import { mapGetters, mapActions } from 'vuex';
import ChooseTimezoneAtLogin from '@/components/modals/ChooseTimezoneAtLogin.vue';

export default {
  computed: {
    ...mapGetters({
      localTimezone: 'timezone/localTimezone',
      choosenTimezone: 'timezone/choosenTimezone',
      lastChoosenTimezone: 'timezone/lastChoosenTimezone',
      checkLastChoosenTimezone: 'timezone/checkLastChoosenTimezone',
      checkUserDefaultTimezone: 'timezone/checkUserDefaultTimezone',
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),
  },

  components: {
    ChooseTimezoneAtLogin,
  },

  methods: {
    ...mapActions({
      setChoosenTimezone: 'timezone/setChoosenTimezone',
    }),

    setOrAskForTimezone() {
      if (this.checkLastChoosenTimezone) {
        const timezonesArray = [this.user.timezone, this.localTimezone];
        this.$modal.show(ChooseTimezoneAtLogin, { timezonesArray },
          { clickToClose: false, adaptive: true });
        return;
      }

      this.setChoosenTimezone(this.lastChoosenTimezone.choosenTimezone);
    },

    setTimezone() {
      if (this.checkUserDefaultTimezone) {
        this.setOrAskForTimezone();
        return;
      }
      this.setChoosenTimezone(this.localTimezone);
    },

    checkFirstDefaultTimezone(selectedTimezone) {
      return (selectedTimezone !== this.localTimezone);
    },

    getTimezonesArray() {
      const timezonesArray = [];
      this.addToArray(timezonesArray, this.localTimezone);
      if (this.authenticated && this.user.timezone) {
        this.addToArray(timezonesArray, this.user.timezone);
      }
      this.addToArray(timezonesArray, this.localTimezone);
      return timezonesArray;
    },

    addToArray(array, value) {
      if (!array.find((elem) => elem === value)) array.push(value);
      return array;
    },
  },
};
